import { render } from "./DownloadImage.vue?vue&type=template&id=22cb40cb&scoped=true"
import script from "./DownloadImage.vue?vue&type=script&lang=js"
export * from "./DownloadImage.vue?vue&type=script&lang=js"

import "./DownloadImage.vue?vue&type=style&index=0&id=22cb40cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cb40cb"]])

export default __exports__